/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetViewResponse {
    getFixupPrototypeFunction() { return BudgetViewResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetViewResponse>): BudgetViewResponse {
        let obj = Object.assign(new BudgetViewResponse(), model);
        BudgetViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetViewResponse>): BudgetViewResponse {
        if (!model) return null;
        return BudgetViewResponse.newInstance(<BudgetViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetViewResponse) {
        if (!obj) return;

        models.BudgetViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetViewResponse): boolean {
        Object.setPrototypeOf(obj, BudgetViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metadata) {
            models.BudgetMetaModel.fixupPrototype(this.metadata);
        }
        if (this.summary) {
            models.BudgetViewSummaryModel.fixupPrototype(this.summary);
        }
    }

    /**
     * threshold uri
     */
    threshold_uri: Array<string>;

    /**
     * The name of the cloud service. For example, AWS.
     */
    cloud: Array<string>;

    /**
     * Cloud account id
     */
    cloud_account_id: Array<string>;

    /**
     * budget created at
     */
    created_at: string;

    /**
     * budget updated at
     */
    updated_at: string;

    /**
     * Name of the user who created the budget
     */
    created_by: string;

    /**
     * Name of the user who updated the budget
     */
    updated_by: string;

    /**
     * tenant id
     */
    tenant_id: string;

    /**
     * true if budget created in corestack
     */
    is_corestack_created: boolean;

    /**
     * true if budget is system budget
     */
    is_tenant_level: boolean;

    /**
     * budget name
     */
    budget_name: string;

    /**
     * budget name
     */
    alias_budget_name: string;

    /**
     * budget creation status
     */
    status: string;

    /**
     * budget type
     */
    budget_type: string;

    /**
     * Specify the budget frequency. Example: budget frequency':'Daily' Allowed values - Daily,Monthly,Quarterly,Annually
     */
    budget_frequency: string;

    /**
     * budget engine
     */
    budget_engine: string;

    /**
     * budget event type
     */
    budget_event_type: string;

    /**
     * budget uri
     */
    budget_uri: string;

    /**
     * metadata to maintain step
     */
    metadata: models.BudgetMetaModel;

    /**
     * Name of the currency
     */
    currency: string;

    /**
     * budget summary data
     */
    summary: models.BudgetViewSummaryModel;

}
